import awsConfig from 'config/awsConfig';
import { webSocket } from 'rxjs/webSocket';

export const connect = (uuid) => {
  if (uuid) {
    const wssUrl = awsConfig.API.endpoints.find((endpoint) => endpoint.name === 'CallbackAPI').endpoint + `?room=${uuid}`;
    return webSocket(wssUrl);
  }
}
